import "core-js/modules/es.array.includes";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { selectIsMobile } from 'redux/modules/device';
import { CmsModules, CmsModuleShape } from 'containers/CmsPage/CmsModules';
import { CmsHeading } from 'components/CmsPage/modules/CmsHeading/CmsHeading';
import { CmsText } from 'components/CmsPage/modules/CmsText/CmsText';
import { Section } from 'components/Section/Section';
var HEIGHTS = ['auto', 'full-screen'];
var HORIZONTAL_POSITIONS = ['left', 'center', 'right'];
var THEMES = ['white', 'light', 'brand', 'dark', 'black'];
var VERTICAL_POSITIONS = ['top', 'middle', 'bottom'];
var WIDTHS = ['auto', 'phone', 'tablet', 'desktop'];
export var CmsSectionUnwrapped = function CmsSectionUnwrapped(_ref) {
  var _classNames;

  var backgroundImage = _ref.backgroundImage,
      cmsModuleId = _ref.cmsModuleId,
      copy = _ref.copy,
      height = _ref.height,
      horizontalPosition = _ref.horizontalPosition,
      modules = _ref.modules,
      theme = _ref.theme,
      title = _ref.title,
      verticalPosition = _ref.verticalPosition,
      width = _ref.width;
  var sectionClasses = classNames((_classNames = {
    CmsSection: true
  }, _defineProperty(_classNames, "CmsSection--height-".concat(height), HEIGHTS.includes(height)), _defineProperty(_classNames, "CmsSection--horizontal-position-".concat(horizontalPosition), HORIZONTAL_POSITIONS.includes(horizontalPosition)), _defineProperty(_classNames, "CmsSection--theme-".concat(theme), THEMES.includes(theme)), _defineProperty(_classNames, "CmsSection--vertical-position-".concat(verticalPosition), VERTICAL_POSITIONS.includes(verticalPosition)), _defineProperty(_classNames, "CmsSection--width-".concat(width), WIDTHS.includes(width)), _classNames));
  var style = backgroundImage ? {
    backgroundImage: "url(".concat(backgroundImage, ")")
  } : null;
  return React.createElement(Section, {
    className: sectionClasses,
    style: style
  }, React.createElement("div", {
    className: "CmsSection__content"
  }, React.createElement(CmsHeading, {
    title: title
  }), React.createElement(CmsText, {
    content: copy,
    cmsModuleId: "Section:Copy:".concat(cmsModuleId)
  }), React.createElement(CmsModules, {
    modules: modules
  })));
};
CmsSectionUnwrapped.propTypes = {
  backgroundImage: PropTypes.string,
  cmsModuleId: PropTypes.string.isRequired,
  copy: PropTypes.string,
  height: PropTypes.string,
  horizontalPosition: PropTypes.string,
  modules: PropTypes.arrayOf(CmsModuleShape),
  theme: PropTypes.string,
  title: PropTypes.string,
  verticalPosition: PropTypes.string,
  width: PropTypes.string
};
export var mapStateToProps = function mapStateToProps(state, props) {
  return {
    backgroundImage: selectIsMobile(state) ? props.imageMobile : props.imageDesktop
  };
};
export var CmsSection = connect(mapStateToProps)(CmsSectionUnwrapped);